module.exports = __webpack_public_path__ + "img/image2.5897b447.png";